var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#girx4dcf3a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.575 7.501a2.5 2.5 0 0 1 4.858.834c0 1.666-2.5 2.5-2.5 2.5M10 14.168h.008m8.325-4.167a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "girx4dcf3a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpLight);
export default __webpack_public_path__ + "static/media/help-light.af120483bd2e68abd2042a46ac26aa23.svg";
export { ForwardRef as ReactComponent };